import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from "../shared/shared.module";

import {SetProductRoutingModule} from './set-product-routing.module';
import {SetProductComponent} from "./set-product.component";

@NgModule({
  declarations: [SetProductRoutingModule.components],
  exports: [SetProductComponent],
  imports: [
    CommonModule,
    SetProductRoutingModule,
    SharedModule
  ]
})

export class SetProductModule {
}
